import { FiAlertCircle } from "react-icons/fi";
import styles from "./styles.module.css";

export const DefaultError = () => {
  return (
    <div className={styles.error}>
      <FiAlertCircle size={14} />
      <span>Preenchimento obrigatório</span>
    </div>
  );
};
